import {
  NewsCenterActionTypes,
  NewsCenterState,
  SET_INITIAL_STATE,
  SET_LOCALE,
} from "./types";

const initialState: NewsCenterState = {
  currentLocale: null,
  newsCenter: null,
  customDomainEnabled: false,
};

export default (
  state = initialState,
  action: NewsCenterActionTypes
): NewsCenterState => {
  switch (action.type) {
    case SET_INITIAL_STATE:
      return {
        ...state,
        ...action,
      };
    case SET_LOCALE:
      return {
        ...state,
        currentLocale: action.locale,
      };
    default:
      return state;
  }
};
